import { createAction } from 'redux-actions';

import { CLEAR_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES } from '../types';

export const clearWatchListEntries = createAction(CLEAR_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES);


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/actions/clearWatchListEntryActions.js